import { Link } from 'react-router-dom';

interface DeckCardBannerProps {
  imageUrl?: string;
  listUrl: string;
}

export const DeckCardBanner = ({ imageUrl, listUrl }: DeckCardBannerProps) => {
  return (
    <Link to={listUrl}>
      <div className="aspect-[2/1] overflow-hidden">
        {imageUrl ? (
          <div className="w-full h-full bg-cover bg-center relative" style={{ backgroundImage: `url(${imageUrl})` }}>
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
          </div>
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-slate-900 via-blue-950 to-black" />
        )}
      </div>
    </Link>
  );
};
